import { render } from "./PageLoader.vue?vue&type=template&id=075062f4&ts=true"
import script from "./PageLoader.vue?vue&type=script&lang=ts"
export * from "./PageLoader.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build_4ed9b393/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__